import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { DEFAULT_BUTTON_WIDTH, SMALLER_BUTTON_WIDTH } from '../../utils/styled/dimensions';

export const DefaultModalComponents = {
  ModalBodyContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-top: 16px;
    padding-right: 8px;
    padding-bottom: 8px;
    width: 100%;
    gap: 12px;
  `,
  ModalButtonsContainer: styled.div`
    width: 100%;
    grid-gap: 24px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    border-top: 1px solid ${AppCSS.colors.greys.light};
    background-color: ${AppCSS.colors.white};
    padding: 16px 8px 8px 0;
    position: sticky;
    bottom: 0;
  `,
  ModalPrimaryButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    padding: 10px 16px;
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.white};
    background-color: ${AppCSS.colors.blues.dark};
    border: none;
    cursor: pointer;
    min-width: ${DEFAULT_BUTTON_WIDTH}px;
    width: ${DEFAULT_BUTTON_WIDTH}px;
  `,
  ModalTertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)`
    min-width: ${SMALLER_BUTTON_WIDTH}px;
    width: ${SMALLER_BUTTON_WIDTH}px;
  `,
};
